package com.dignicate.web.domain

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.StateFlow

class GetCompanyContentUseCase(
    private val repository: ContentRepository,
    private val lang: Language,
    scope: CoroutineScope = CoroutineScope(Dispatchers.Default)
) {
    private val fetchTrigger = MutableSharedFlow<Unit>(replay = 1)

    val data: StateFlow<Resource<CompanyContent>> =
        fetchTrigger.mapToResource(
            scope = scope,
            then = { repository.getCompanyContent(lang) }
        )

    suspend fun fetch() {
        fetchTrigger.emit(Unit)
    }
}
